import { Button } from './ui/button';
import { motion } from 'framer-motion';

export default function FinancingBanner() {
	return (
		<motion.section 
			initial={{ opacity: 0, y: 30 }}
			animate={{ opacity: 1, y: 0 }}
			transition={{ duration: 0.8 }}
			className="animated-gradient particle-container subtle-glow"
		>
			<div className="container py-6 md:py-8 text-white flex flex-col md:flex-row items-center justify-between gap-4">
				<motion.div
					initial={{ opacity: 0, x: -30 }}
					animate={{ opacity: 1, x: 0 }}
					transition={{ duration: 0.6, delay: 0.2 }}
				>
					<motion.div 
						initial={{ opacity: 0, y: 20 }}
						animate={{ opacity: 1, y: 0 }}
						transition={{ duration: 0.6, delay: 0.3 }}
						className="text-sm uppercase tracking-wide opacity-90"
					>
						Drive Now, Pay Later
					</motion.div>
					<motion.h3 
						initial={{ opacity: 0, y: 20 }}
						animate={{ opacity: 1, y: 0 }}
						transition={{ duration: 0.6, delay: 0.4 }}
						className="text-xl md:text-2xl font-bold"
					>
						0% for 12 months with approved credit
					</motion.h3>
					<motion.p 
						initial={{ opacity: 0, y: 20 }}
						animate={{ opacity: 1, y: 0 }}
						transition={{ duration: 0.6, delay: 0.5 }}
						className="text-white/90"
					>
						Financing options via Affirm and Klarna. Subject to approval. Terms apply.
					</motion.p>
				</motion.div>
				<motion.div 
					initial={{ opacity: 0, x: 30 }}
					animate={{ opacity: 1, x: 0 }}
					transition={{ duration: 0.6, delay: 0.6 }}
					className="flex gap-3"
				>
					<motion.a 
						href="/resources" 
						className="hidden md:block"
						whileHover={{ scale: 1.05 }}
						whileTap={{ scale: 0.95 }}
					>
						<Button variant="outline" className="border-white text-white hover:bg-white/10 bg-transparent">Learn More</Button>
					</motion.a>
					<motion.a 
						href="https://getstarted.ubiquityglass.com" 
						target="_blank" 
						rel="noreferrer"
						whileHover={{ scale: 1.05 }}
						whileTap={{ scale: 0.95 }}
					>
					<Button className="bg-white text-secondary hover:opacity-90 dark:bg-transparent dark:border dark:border-white dark:text-white dark:hover:bg-white/10">Apply at Checkout</Button>
					</motion.a>
				</motion.div>
			</div>
		</motion.section>
	);
}
